<template>
  <div>
    <div v-if="houses.length >= 2">
      <h2 class="subTitle">Seleziona la proprietà: </h2>
      <v-select :options="houses" v-on:input="changeEvent"></v-select>
      <house-document-altro v-if="house_id" v-bind:houseId="house_id" :key="componentKey"></house-document-altro>
    </div>
    <div v-else>
      <div v-if="house_id">
        <house-document-altro v-if="house_id" v-bind:houseId="house_id" :key="componentKey"></house-document-altro>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['ownerId'],
  data: function () {
    return {
      componentKey: 0,
      houses: [],
      house_id: '',
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    changeEvent(a) {
      this.forceRerender()
      if (a) {
        this.house_id = a.code;
      } else {
        this.house_id = '';
      }
    },
    getHouses() {
      axios.get('/api/get-owner-houses/' + this.ownerId)
          .then(response => {
                this.houses = response.data.body;
                if (this.houses.length < 2) {
                  this.house_id = this.houses[0].code;
                }
              }
          )
    }
  },
  mounted() {
    this.getHouses()
  }
}
</script>

<style scoped>

</style>